export default __webpack_public_path__ + "static/media/ds-dark.22fd2826.svg";